import {useReducer, useState} from 'react'
import { changeStep } from '../../components/Store/reducers/stepReducer/actions'
import { stepStatus, skippedSteps } from '../../components/Store/reducers/stepReducer/initialState'
import {
    displayReducer,
    formReducer,
} from '../../components/Store/reducers/formReducer/actions'
import {
    displayValues,
    formValues,
} from '../../components/Store/reducers/formReducer/initialState'
import {
    HandleNextFunction,
    HandlePrevFunction,
    SetDisplayValueFunction,
    SetFormValueFunction,
    SetSkippedStepsFunction,
    SetStepStatusFunction,
    UpdateUserResumeFunction,
    UseStepHandlerReturn,
    UseStepHandlerProps,
} from './types'

export const useStepHandler = (props?: UseStepHandlerProps): UseStepHandlerReturn => {
    const [isBlocking, setIsBlocking] = useState(false)
    const [stepState, dispatchStep] = useReducer(changeStep, {
        currentStep: { currentStep: 0 },
        stepStatus: stepStatus,
        skippedSteps: skippedSteps,
    })
    const initialFormState = { ...formValues, ...(props?.initialFormState || {}) }
    const initialDisplayState = { ...displayValues, ...(props?.initialDisplayState || {}) }
    const [formState, formDispatch] = useReducer(formReducer, initialFormState)
    const [displayState, displayDispatch] = useReducer(
        displayReducer,
        initialDisplayState
    )

    const handleNext: HandleNextFunction = () => {
        setIsBlocking(true)
        dispatchStep({ type: 'nextStep' })
        setTimeout(() => {
            setIsBlocking(false)
        }, 600)
    }

    const handlePrev: HandlePrevFunction = () => {
        setIsBlocking(true)
        dispatchStep({ type: 'prevStep' })
        setTimeout(() => {
            setIsBlocking(false)
        }, 600)
    }

    const setStepStatus: SetStepStatusFunction = (key, value) => {
        dispatchStep({ type: 'setStepStatus', key, value })
    }

    const setSkippedSteps: SetSkippedStepsFunction = steps => {
        dispatchStep({ type: 'setSkippedSteps', steps })
    }

    const setDisplayValue: SetDisplayValueFunction = (
        displayFormKey,
        displayFormValue
    ) => {
        displayDispatch({
            type: 'displayFormValue',
            payload: {
                displayKey: displayFormKey,
                displayValue: displayFormValue,
            },
        })
    }

    const setFormValue: SetFormValueFunction = (formKey, inputValue) => {
        formDispatch({
            type: 'changeFormValue',
            payload: { key: formKey, value: inputValue },
        })
    }

    const updateUserResume: UpdateUserResumeFunction = (
        index,
        formKey,
        inputValue
    ) => {
        formDispatch({
            type: 'changeUserResumeValue',
            payload: { index, key: formKey, value: inputValue },
        })
    }

    return {
        stepState,
        displayState,
        formState,
        handleNext,
        handlePrev,
        setFormValue,
        updateUserResume,
        setDisplayValue,
        setStepStatus,
        setSkippedSteps,
        isBlocking
    }
}
